import {postRegistration} from '../api/postRegistration';
import { setPostAuthorization } from './setPostAuthorization';

export const setPostRegistration = (params, setErrorRegistration, setLoading) => {
    return async (dispatch, getState) => {
        try {
            params.organization = 1;
            params.utm_source = localStorage.getItem('utm_source');
            params.utm_medium = localStorage.getItem('utm_medium');
            params.utm_campaign = localStorage.getItem('utm_campaign');
            params.utm_content = localStorage.getItem('utm_content');
            params.utm_term = localStorage.getItem('utm_term');
            
            params.stream = localStorage.getItem('stream');
            params.s1 = localStorage.getItem('s1');
            params.s2 = localStorage.getItem('s2');
            params.s3 = localStorage.getItem('s3');
            params.s4 = localStorage.getItem('s4');
            params.s5 = localStorage.getItem('s5');
            params.partners = true;

            const {data} = await postRegistration(params);
            if (data.status === 'success') {
                dispatch(setPostAuthorization({
                    login: params.code + params.login,
                    password: params.password,
                    organization: params.organization
                }))
            }
        } catch(error) {
            setLoading(false)
            if (error && error.response && error.response.data && error.response.data.message === 'user is already') {
                setErrorRegistration(true)
            }
        }
    }
}